import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';

export const dcPaymentTypeSchema = baseObjectSchema.extend({
  paymentTypeId: z.string(),
  representativeId: z.string(),
  paymentMethodRemotedCode: z.string(),
  paymentType: baseSchema.optional(),
});

export const getDCPaymentTypesResponseSchema = z.object({
  data: z.array(dcPaymentTypeSchema),
});

export type GetDCPaymentTypesResponse = z.infer<typeof getDCPaymentTypesResponseSchema>;
